<section>
  <header class="accordion-heading helvetica-neue-regular-font" [class.cursor-pointer]="toggleOnHeaderClick"
    (click)="toggleOnHeaderClick ? toggle.emit() : ''">
    <span class="vo-heading-regular-20" [innerHtml]="title"></span>
    <ng-content select="[header]"></ng-content>
    <span (click)="!toggleOnHeaderClick ? toggle.emit() : ''" class="accordion-status-icon"
      [ngClass]="expanded ? 'accordion-status-icon-close' : 'accordion-status-icon-open'"></span>
  </header>
  <div [@preventFirstAnimation]>
    <div class="accordion-body" [@expandCollapseItem] *ngIf="expanded">
      <ng-content></ng-content>
    </div>
  </div>
</section>